module.exports = __webpack_public_path__ + "media/images/story-desktop-653560f5.jpg";